module.exports = __webpack_public_path__ + "static/media/fasad10.8a768716.jpeg";